import React, { useState, useEffect } from 'react';

const RadioList = ({
  inputName,
  options,
  register,
  defaultValue,
  onChange,
  oneColumn = false,
  error,
  setError,
}) => {
  const [value, setValue] = useState(defaultValue || null);

  useEffect(() => {
    if (onChange) {
      onChange(value);
    }
  }, [value]);

  return (
    <div className={`custom-radio-wrapper${oneColumn ? '--one-column' : ''}`}>
      {error && (
        <p className="typography__error mb-2xs">
          <small className="error-message">
            <b>{error}</b>
          </small>
        </p>
      )}
      {Object.entries(options).map(([optionValue, optionLabel]) => (
        <label className="custom-radio-btn" key={optionValue}>
          <input
            type="radio"
            name={inputName}
            value={optionValue}
            ref={register}
            defaultChecked={defaultValue === optionValue}
            onClick={() => {
              setValue(optionValue);
              if (setError) setError(null);
            }}
          />
          <span className={`radio-tick ${error ? 'error' : ''}`}></span>
          <p className={`option-name ${error ? 'typography__error' : ''}`}>
            {optionLabel}
          </p>
        </label>
      ))}
    </div>
  );
};

export { RadioList };
